import { APP_TERMS } from './app-terms';
import {
  dashboard,
  menuicon06,
  menuicon08,
  menuicon13,
  menuicon09,
  patients,
  health_img,
} from './components/imagepath';

export const AppLocales = {
  enUs: 'enUs',
};
/** Used by list/search inputs (`useDebounce`, `SearchInput`, `BranchList`). */
export const DEFAULT_DEBOUNCE_INTERVAL = 300;
export const CASE_FORM_TYPES = {
  patientDetails: 'PATIENT_DETAILS',
  studyPurpose: 'STUDY_PURPOSE',
  addServices: 'ADD_SERVICES',
  uploadFiles: 'UPLOAD_FILES',
};
export const UPLOAD_STATUS = {
  success: 'SUCCESS',
  failure: 'FAILURE',
};
export const APP_USER_TYPES = {
  clinicUser: 'clinicUser',
};
export const APP_MASTER_TYPES = {
  service: 'service',
};
export const STUDY_PURPOSES = [
  { label: APP_TERMS.airway_label, fieldName: 'airwayFlag' },
  { label: APP_TERMS.generic_general, fieldName: 'generalFlag' },
  { label: APP_TERMS.impaction_label, fieldName: 'impactionFlag' },
  { label: APP_TERMS.implant_label, fieldName: 'implantFlag' },
  { label: APP_TERMS.orthodontic_label, fieldName: 'orthodonticFlag' },
  { label: APP_TERMS.pathology_label, fieldName: 'pathologyFlag' },
  { label: APP_TERMS.sinus_label, fieldName: 'sinusFlag' },
  { label: APP_TERMS.tmd_pain_label, fieldName: 'painFlag' },
];
export const SIDEBAR_ITEMS = [
  {
    to: '/user/admin-dashboard',
    id: 'dashboard',
    title: 'Dashboard',
    icon: dashboard,
  },
  {
    id: 'cases',
    title: APP_TERMS.generic_case,
    icon: menuicon13,
    to: '/user/case/submitted',
    children: [
      {
        id: 'casesubmitted',
        to: '/user/case/submitted',
        title: 'Submitted',
        activeClassName: 'case-submitted',
      },
      {
        id: 'caseawaitingapproval',
        to: '/user/case/awaiting-approval',
        title: 'Awaiting Approval',
        activeClassName: 'case-awaiting-approval',
      },
      {
        id: 'casecompleted',
        to: '/user/case/completed',
        title: 'Completed',
        activeClassName: 'case-completed',
      },
    ],
  },
  {
    id: 'clinics',
    title: 'Clinics',
    icon: health_img,
    to: '/user/cliniclist',
    children: [
      {
        id: 'cliniclist',
        to: '/user/cliniclist',
        title: 'List',
        activeClassName: 'clinic-list',
      },
    ],
  },
  {
    id: 'radiologists',
    title: 'Radiologists',
    icon: menuicon08,
    to: '/user/radiologistlist',
    children: [
      {
        id: 'radiologistlist',
        to: '/user/radiologistlist',
        title: 'List',
        activeClassName: 'radiologist-list',
      },
      {
        id: 'radiologist-invoice-list',
        to: '/user/radiologist-invoice-list',
        title: 'Revenue',
        activeClassName: 'radiologist-invoice-list',
      },
    ],
  },
  {
    id: 'patients',
    title: 'Patients',
    icon: patients,
    to: '/user/patientslist',
    children: [
      {
        id: 'patientlist',
        to: '/user/patientslist',
        title: 'Patients List',
        activeClassName: 'patient-list',
      },
      {
        id: 'addpatient',
        to: '/user/addpatients',
        title: 'Add Patients',
        activeClassName: 'add-patient',
      },
    ],
  },
  {
    id: 'users',
    title: 'Staff',
    icon: menuicon08,
    to: '/user/userslist',
    children: [
      {
        id: 'stafflist',
        to: '/user/userslist',
        title: 'Staff List',
        activeClassName: 'user-list',
      },
    ],
  },
  {
    id: 'branches',
    title: 'Branch',
    icon: menuicon06,
    to: '/user/branchlist',
    children: [
      {
        id: 'branchlist',
        to: '/user/branchlist',
        title: 'List',
        activeClassName: 'branch-List',
      },
    ],
  },
  {
    id: 'revenue',
    title: APP_TERMS.generic_invoice,
    icon: menuicon09,
    to: '/user/invoicelist',
    children: [
      {
        id: 'invoicelist',
        to: '/user/invoicelist',
        title: 'List',
        activeClassName: 'invoice-list',
      },
      {
        id: 'invoice-footer-content',
        to: '/user/invoice-footer-content',
        title: 'Footer Content',
        activeClassName: 'invoice-footer-content',
      },
      {
        id: 'invoice-report-list',
        to: '/user/invoice-report-list',
        title: 'Report',
        activeClassName: 'invoice-report-list',
      },
    ],
  },
];

export const LOGIN_FORM_TYPES = {
  NEW_PASSWORD_REQUIRED: 'NEW_PASSWORD_REQUIRED',
  CUSTOM_CHALLENGE: 'CUSTOM_CHALLENGE',
};
export const WORD_FILE_MIME_TYPE =
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
export const CLINIC_STATUS_ENUM = {
  APPROVED: 'APPROVED',
  CREATED: 'CREATED',
  DISAPPROVE: 'DISAPPROVE',
  ENABLE: 'ENABLE',
  DISABLE: 'DISABLE',
};
export const CLINIC_PAYMENT_METHOD_ENUM = {
  PAY_AS_YOU_GO: 'PAY_AS_YOU_GO',
  MONTHLY: 'MONTHLY',
};
export const CLINIC_STATUS_OPTIONS = [
  { label: 'APPROVED', value: 'APPROVED', disabled: false },
  { label: 'CREATED', value: 'CREATED', disabled: true },
  { label: 'DISAPPROVE', value: 'DISAPPROVE', disabled: false },
  { label: 'DISABLE', value: 'DISABLE', disabled: false },
];
export const CLINIC_PAYMENT_METHOD_OPTIONS = [
  { label: 'PAY AS YOU GO', value: 'PAY_AS_YOU_GO', disabled: false },
  { label: 'MONTHLY', value: 'MONTHLY', disabled: false },
];
export const CLINIC_PAYMENT_METHOD_ENUM_OPTIONS = [
  { label: 'PAY AS YOU GO', value: 'PAY_AS_YOU_GO' },
  { label: 'MONTHLY', value: 'MONTHLY' },
];
export const MONTHS_WITH_ZERO_INDEX = [
  { label: 'January', value: 0 },
  { label: 'February', value: 1 },
  { label: 'March', value: 2 },
  { label: 'April', value: 3 },
  { label: 'May', value: 4 },
  { label: 'June', value: 5 },
  { label: 'July', value: 6 },
  { label: 'August', value: 7 },
  { label: 'September', value: 8 },
  { label: 'October', value: 9 },
  { label: 'November', value: 10 },
  { label: 'December', value: 11 },
];
/**
 * @description Dynamic calculation of last ten years
 */
export const getLastTenYears = () => [
  ...Array.from({ length: 10 }, (_, i) => {
    const year = new Date().getFullYear() - i;
    return { label: year.toString(), value: year };
  }).reverse(),
];
export const DATE_FORMAT = "MM-DD-YYYY";